import { BgColorPalette } from '@/constants';
import styled from 'styled-components';

export const StyledCourierSettings = styled.div`
  .list-sortable {
    cursor: move;
    padding: 0.5rem 1rem;
    border: 1px solid ${BgColorPalette.SECONDARY_HOVER};
    display: flex;
    align-items: center;
    justify-content: space-between;
    img {
      width: 2rem;
      height: 2rem;
    }
    .left-item {
      display: flex;
      align-items: center;
    }
    .Polaris-Button--iconOnly {
      padding: rem;
    }
  }
`;
